import React from 'react';
import { UserRole } from '../types/commission';
import { Shield, User } from 'lucide-react';
import { motion } from 'framer-motion';
interface RoleSwitcherProps {
  currentRole: UserRole;
  onRoleChange: (role: UserRole) => void;
}
export function RoleSwitcher({
  currentRole,
  onRoleChange
}: RoleSwitcherProps) {
  return <div className="flex items-center bg-navy-800/60 p-1 rounded-lg border border-white/10" data-id="element-1239">
      <button onClick={() => onRoleChange('Loan Officer')} className={`relative flex items-center gap-2 px-3 py-1.5 text-sm font-medium rounded-md transition-colors z-10 ${currentRole === 'Loan Officer' ? 'text-accent-400' : 'text-slate-400 hover:text-slate-200'}`} data-id="element-1240">
        {currentRole === 'Loan Officer' && <motion.div layoutId="role-bg" className="absolute inset-0 bg-navy-700/80 shadow-sm rounded-md border border-accent-400/20 -z-10" transition={{
        type: 'spring',
        bounce: 0.2,
        duration: 0.6
      }} data-id="element-1241" />}
        <User size={14} data-id="element-1242" />
        <span data-id="element-1243">Loan Officer</span>
      </button>

      <button onClick={() => onRoleChange('System Administrator')} className={`relative flex items-center gap-2 px-3 py-1.5 text-sm font-medium rounded-md transition-colors z-10 ${currentRole === 'System Administrator' ? 'text-accent-400' : 'text-slate-400 hover:text-slate-200'}`} data-id="element-1244">
        {currentRole === 'System Administrator' && <motion.div layoutId="role-bg" className="absolute inset-0 bg-navy-700/80 shadow-sm rounded-md border border-accent-400/20 -z-10" transition={{
        type: 'spring',
        bounce: 0.2,
        duration: 0.6
      }} data-id="element-1245" />}
        <Shield size={14} data-id="element-1246" />
        <span data-id="element-1247">System Admin</span>
      </button>
    </div>;
}